
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStagePrzesunZadanieOprawaGold(draggedId,targetId,procesorId,dropDate,refreshGantAll) {

// id = procesor id
  
  axios
  .get(IP + "API_0022_gant_procedura_przesun_zadanie_oprawa_gold/"+draggedId+"/"+targetId+"/"+procesorId+"/"+dropDate+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}


